import React from 'react';
import AboutQAContent from '../function-components/AboutQAContent';

function AboutQA() {
  return (
    <>
    <AboutQAContent />
    </>
  )
}

export default AboutQA;